import { Injectable } from '@angular/core';

export interface StringInstrumentParamters {
  strings: number,
  opennotes: number[],
  defaultopen: number[],
  sound: string,
  min: number, max: number,
  octaves: number
}

@Injectable({
  providedIn: 'root'
})
export class StringsService {

  public withFingering = true;

  // opennotes : 0 is the C before the 5 strings bass B string
  // so bass5, first string is 11
  // bass4, first string is 16 (E string)
  // guitar, first string is 28 (E string)

  public stringsInstruFamilies = ['guitar', 'bass', 'ukulele', 'baritone'];

  public stringsInstru: { [instru: string]: StringInstrumentParamters } = {
    guitar6: {
      strings: 6,
      opennotes: [28, 33, 38, 43, 47, 52],
      defaultopen: [28, 33, 38, 43, 47, 52],
      sound: 'acoustic_guitar_steel-mp3',
      min: 23, max: 71,
      octaves: 3
    },
    manouche6: {
      strings: 6,
      opennotes: [28, 33, 38, 43, 47, 52],
      defaultopen: [28, 33, 38, 43, 47, 52],
      sound: 'acoustic_guitar_steel-mp3',
      min: 23, max: 71,
      octaves: 3
    },
    guitar7: {
      strings: 7,
      opennotes: [23, 28, 33, 38, 43, 47, 52],
      defaultopen: [23, 28, 33, 38, 43, 47, 52],
      sound: 'acoustic_guitar_steel-mp3',
      min: 18, max: 71,
      octaves: 3
    },
    guitar8: {
      strings: 8,
      opennotes: [18, 23, 28, 33, 38, 43, 47, 52],
      defaultopen: [18, 23, 28, 33, 38, 43, 47, 52],
      sound: 'acoustic_guitar_steel-mp3',
      min: 12, max: 71,
      octaves: 3
    },
    ukulele4: {
      strings: 4,
      opennotes: [43, 36, 40, 45],
      defaultopen: [43, 36, 40, 45],
      sound: 'acoustic_guitar_steel-mp3',
      min: 31, max: 64,
      octaves: 1
    },
    baritone4: {
      strings: 4,
      opennotes: [26, 31, 35, 40],
      defaultopen: [26, 31, 35, 40],
      sound: 'acoustic_guitar_steel-mp3',
      min: 12, max: 71,
      octaves: 3
    },
    others4: {
      strings: 4,
      opennotes: [26, 31, 35, 40],
      defaultopen: [26, 31, 35, 40],
      sound: 'acoustic_guitar_steel-mp3',
      min: 12, max: 71,
      octaves: 1
    },
    bass4: {
      strings: 4,
      opennotes: [16, 21, 26, 31],
      defaultopen: [16, 21, 26, 31],
      sound: 'electric_bass_finger-mp3',
      min: 11, max: 50,
      octaves: 2
    },
    bass5: {
      strings: 5,
      opennotes: [11, 16, 21, 26, 31],
      defaultopen: [11, 16, 21, 26, 31],
      sound: 'electric_bass_finger-mp3',
      min: 9, max: 50,
      octaves: 2
    },
    bass6: {
      strings: 6,
      opennotes: [11, 16, 21, 26, 31, 36],
      defaultopen: [11, 16, 21, 26, 31, 36],
      sound: 'electric_bass_finger-mp3',
      min: 9, max: 55,
      octaves: 2
    }
  };

  getOpenNotes(instru: string, nbstrings: number): number[] {
    return this.stringsInstru[instru + nbstrings.toString()].opennotes;
  }
  getDefaultOpenNotes(instru: string, nbstrings: number): number[] {
    return this.stringsInstru[instru + nbstrings.toString()].defaultopen;
  }
  isOpen(instru: string, nbstrings: number, str?: number) {
    if (typeof str === 'undefined') {
      return (!this.arraysEqual(
        this.getOpenNotes(instru, nbstrings),
        this.getDefaultOpenNotes(instru, nbstrings)));
    }
    return (this.getOpenNotes(instru, nbstrings)[str] === this.getDefaultOpenNotes(instru, nbstrings)[str]);
  }
  arraysEqual(a1: any[], a2: any[]) {
    if (a1.length !== a2.length) {
      return false;
    }
    return JSON.stringify(a1) === JSON.stringify(a2);
  }
  isExtended(instru: string, nbStrings: number) {
    return (nbStrings !== this.getStandardNbStrings(instru));
  }
  getStandardNbStrings(instru: string) {
    if (instru === 'ukulele') {
      return 4;
    }
    if (instru === 'baritone') {
      return 4;
    }
    if (instru === 'guitar') {
      return 6;
    }
    if (instru === 'manouche') {
      return 6;
    }
    if (instru === 'bass') {
      return 4;
    }
    return 0;
  }
}
